import { render, staticRenderFns } from "./warehouse-setting-popover.vue?vue&type=template&id=226a0d6a&"
import script from "./warehouse-setting-popover.vue?vue&type=script&lang=js&"
export * from "./warehouse-setting-popover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports